import { createHttpLink } from '@apollo/client/core';
import { EEnvironment } from '@/entities';
import { BaseUrlController } from '#shared/api';

const baseUrlController = new BaseUrlController({
  baseUrlEnvKey: 'VITE_APP_GQL_URL',
});
baseUrlController.add(EEnvironment.PRODUCTION, 'https://graphql.kazanexpress.ru/');
baseUrlController.add(EEnvironment.RELEASE, 'https://graphql.prod.internal.kznexpess.com/');
baseUrlController.add(
  EEnvironment.DEVELOPMENT,
  'https://graphql-gateway.dev.cluster.kznexpess.com'
);

const uri = baseUrlController.getBaseUrl();

export const httpLink = createHttpLink({ uri });
